module.exports = __webpack_public_path__ + "static/img/image086.a491fe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image086.png
// module id = VGwj
// module chunks = 1